import React from 'react'
import { FormattedMessage } from 'react-intl'
import Tooltip from 'components/Tooltip'
import InfoIcon from 'assets/icons/info-icon'
import { PageTitle, PageSubtitleWrapper, PageSubtitle, TooltipHintWrapper } from './style'

const AssessmentTitle = ({
  titleId,
  subTitleId,
  tooltipId,
  marginTop='168px',
  marginBottom='64px',
  fontSizePageSubtitle = '16px'
}) => {
  const tooltipXOffset = 0
  const tooltipYOffset = 16
  return (
    <>
      <PageTitle data-testid="test-page-title" marginTop={marginTop} data-test='legend'>
        <FormattedMessage id={titleId} />
      </PageTitle>
      <PageSubtitleWrapper data-testid="test-page-subtitle-wrapper" data-test='sub-legend' marginBottom={marginBottom}>
        <PageSubtitle data-testid='test-page-subtitle' fontSizePageSubtitle={fontSizePageSubtitle}>
          <FormattedMessage id={subTitleId} />
        </PageSubtitle>
        {tooltipId && (
          <Tooltip
            style={{ zIndex: 1000 }}
            placement='bottom'
            trigger={['hover']}
            align={{ offset: [tooltipXOffset, tooltipYOffset] }}
            overlay={{ label: `${titleId}`, infoTooltip: `${tooltipId}` }}
            type='big'
          >
            <TooltipHintWrapper data-testid="test-tooltip-icon-wrapper">
              <InfoIcon />
            </TooltipHintWrapper>
          </Tooltip>
        )}
      </PageSubtitleWrapper>
    </>
  )
}

export default AssessmentTitle
